import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as RoleActions from './roles.actions';
import { RolesService } from 'app/modules/administration/access-control/roles/roles.service';
import { catchError, map, mergeMap, of } from 'rxjs';

@Injectable()
export class RolesEffects {
  constructor(private actions$: Actions, private roleService: RolesService) {}

  loadRoles$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.loadRoles),
      mergeMap(() =>
        this.roleService.getAll().pipe(
          map((roles) => RoleActions.loadRolesSuccess({ roles })),
          catchError((error) => of(RoleActions.loadRolesFailure({ error })))
        )
      )
    )
  );

  createRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.createRole),
      mergeMap(({ role }) => {
        console.log('🚀 [NgRx Effect] Creating role with data:', role);
        return this.roleService.create(role).pipe(
          map((created) => {
            console.log('✅ [NgRx Effect] Role created successfully:', created);
            return RoleActions.createRoleSuccess({ role: created });
          }),
          catchError((error) => {
            console.error('❌ [NgRx Effect] Role creation failed:', error);
            console.error('Error details:', error.error || error.message);
            return of(RoleActions.createRoleFailure({ error }));
          })
        );
      })
    )
  );

  updateRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.updateRole),
      mergeMap(({ id, role }) => {
        console.log('🔄 [NgRx Effect] Updating role:', id, role);
        return this.roleService.update(id, role).pipe(
          map((updated) => {
            console.log('✅ [NgRx Effect] Role updated successfully:', updated);
            return RoleActions.updateRoleSuccess({ role: updated });
          }),
          catchError((error) => {
            console.error('❌ [NgRx Effect] Role update failed:', error);
            return of(RoleActions.updateRoleFailure({ error }));
          })
        );
      })
    )
  );

  softDeleteRole$ = createEffect(() =>
    this.actions$.pipe(
      ofType(RoleActions.softDeleteRole),
      mergeMap(({ id, updatedBy }) =>
        this.roleService.softDelete(id, updatedBy).pipe(
          map(() => RoleActions.softDeleteRoleSuccess({ id })),
          catchError((error) => of(RoleActions.softDeleteRoleFailure({ error })))
        )
      )
    )
  );
}
